module.exports = __webpack_public_path__ + "static/media/2013.61777c25.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2013.png
// module id = 594
// module chunks = 0